import { createIcon } from '@chakra-ui/react'

export const PathIcon = createIcon({
  displayName: 'PathIcon',
  path: (
    <>
      <g clipPath='url(#clip0_636_4564)'>
        <path
          d='M5.75 33.25C5.75 34.1783 6.11875 35.0685 6.77513 35.7249C7.4315 36.3813 8.32174 36.75 9.25 36.75C10.1783 36.75 11.0685 36.3813 11.7249 35.7249C12.3813 35.0685 12.75 34.1783 12.75 33.25C12.75 32.3217 12.3813 31.4315 11.7249 30.7751C11.0685 30.1187 10.1783 29.75 9.25 29.75C8.32174 29.75 7.4315 30.1187 6.77513 30.7751C6.11875 31.4315 5.75 32.3217 5.75 33.25Z'
          stroke='white'
          strokeOpacity='0.36'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M33.75 12.25C34.6783 12.25 35.5685 11.8813 36.2249 11.2249C36.8813 10.5685 37.25 9.67826 37.25 8.75C37.25 7.82174 36.8813 6.9315 36.2249 6.27513C35.5685 5.61875 34.6783 5.25 33.75 5.25C32.8217 5.25 31.9315 5.61875 31.2751 6.27513C30.6187 6.9315 30.25 7.82174 30.25 8.75C30.25 9.67826 30.6187 10.5685 31.2751 11.2249C31.9315 11.8813 32.8217 12.25 33.75 12.25Z'
          stroke='white'
          strokeOpacity='0.36'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M19.75 33.25H29.375C30.9995 33.25 32.5574 32.6047 33.706 31.456C34.8547 30.3074 35.5 28.7495 35.5 27.125C35.5 25.5005 34.8547 23.9426 33.706 22.794C32.5574 21.6453 30.9995 21 29.375 21H15.375C13.7505 21 12.1926 20.3547 11.044 19.206C9.89531 18.0574 9.25 16.4995 9.25 14.875C9.25 13.2505 9.89531 11.6926 11.044 10.544C12.1926 9.39531 13.7505 8.75 15.375 8.75H23.25'
          stroke='white'
          strokeOpacity='0.36'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_636_4564'>
          <rect width='42' height='42' fill='white' transform='translate(0.5)' />
        </clipPath>
      </defs>
    </>
  ),
  viewBox: '0 0 43 42',
})
